window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

	/**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
	pageLinkFocus: function($element) {
		var focusClass = "js-focus-hidden";

		$element.first()
			.attr("tabIndex", "-1")
			.focus()
			.addClass(focusClass)
			.one("blur", callback);

		function callback() {
			$element.first()
				.removeClass(focusClass)
				.removeAttr("tabindex");
		}
	},

	/**
   * If there's a hash in the url, focus the appropriate element
   */
	focusHash: function() {
		var hash = window.location.hash;

		// is there a hash in the url? is it an element on the page?
		if (hash && document.getElementById(hash.slice(1))) {
			this.pageLinkFocus($(hash));
		}
	},

	/**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
	bindInPageLinks: function() {
		$("a[href*=#]").on("click", function(evt) {
			this.pageLinkFocus($(evt.currentTarget.hash));
		}.bind(this));
	},

	/**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
	trapFocus: function(options) {
		var eventName = options.eventNamespace
			? "focusin." + options.eventNamespace
			: "focusin";

		if (!options.$elementToFocus) {
			options.$elementToFocus = options.$container;
		}

		options.$container.attr("tabindex", "-1");
		options.$elementToFocus.focus();

		$(document).on(eventName, function(evt) {
			if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
				options.$container.focus();
			}
		});
	},

	/**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
	removeTrapFocus: function(options) {
		var eventName = options.namespace
			? "focusin." + options.namespace
			: "focusin";

		if (options.$container && options.$container.length) {
			options.$container.removeAttr("tabindex");
		}

		$(document).off(eventName);
	}
};

/**
* Cart Template Script
* ------------------------------------------------------------------------------
* A file that contains scripts highly couple code to the Cart template.
*
* @namespace cart
*/

slate.cart = (function() {
	var _instance = {};

	_instance.cartCount = parseInt($("#cartCount").val());

	_instance.init = function(){
		var $cartQty = $("body.template-cart .product-quantity");

		if ($cartQty.length){
			$cartQty.find("button").click(qtyButtonHandler);
		}

		if(sessionStorage.collection !== "undefined"){
			$("#continueShopping").attr("href", sessionStorage.collection);
			$("#continueShopping").click(function(evt){
				evt.preventDefault();
				window.location = $(this).attr('href');
			});
		}
	};

	var qtyButtonHandler = function(e){
		e.preventDefault();
		var $this = $(this);
		var $input = $this.siblings("input");
		var inputVal = parseInt($input.val());
		if ($this.hasClass("plus")){
			inputVal++;
			$input.val(inputVal);
		} else {
			inputVal--;
			$input.val(inputVal);
		}
		_instance.changeItem(parseInt($input.attr("data-line")), inputVal, function(data){
			$.each( data.items, function( key, value ) {
				if(value.variant_id == $input.attr("data-variant-id")){
					if(value.quantity != inputVal){
						$input.val(value.quantity);
						alert("Sorry, there are no more of this item available");
						_instance.changeItem(parseInt($input.attr("data-line")), value.quantity);
					}
				}
			});
		});
	};

	_instance.addItem = function(params){
		if (typeof(params.quantity) === "undefined"){
			params.quantity = 1;
		}
		if (typeof(params.fail) === "undefined"){
			params.fail = function(){};
		}

		$.post("/cart/add.js", {quantity: params.quantity, id: params.id }).always(function(data){
			var jsonResp = JSON.parse(data.responseText);
			if (data.status == 200) {
				params.success(jsonResp);
			} else {
				//422 is unprocessible - often due to all of the items in stock being in the cart
				params.fail(jsonResp);
			}
		});
	};

	_instance.rmvItem = function(line, callback){
		$.post("/cart/change.js", {quantity: 0, line: parseInt(line)})
			.always(callback);
	};

	_instance.changeItem = function(line, qty, success, fail){
		if (typeof(success) === "undefined"){
			success = function(){};
		}
		if (typeof(fail) === "undefined"){
			fail = function(){};
		}
		$.post("/cart/change.js", {line: line, quantity: qty}).always(function(data){
			var jsonResp = JSON.parse(data.responseText);
			if (data.status == 200) {
				success(jsonResp);
			} else {
				//422 is unprocessible - often due to all of the items in stock being in the cart
				fail(jsonResp);
			}
		});
	};

	/**
	 * Browser cookies are required to use the cart. This function checks if
	 * cookies are enabled in the browser.
	 */
	_instance.cookiesEnabled = function() {
		var cookieEnabled = navigator.cookieEnabled;

		if (!cookieEnabled){
			document.cookie = "testcookie";
			cookieEnabled = (document.cookie.indexOf("testcookie") !== -1);
		}
		return cookieEnabled;
	};
	return _instance;
})();
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

	/**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
	findInstance: function(array, key, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i][key] === value) {
				return array[i];
			}
		}
	},

	/**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
	removeInstance: function(array, key, value) {
		var i = array.length;
		while(i--) {
			if (array[i][key] === value) {
				array.splice(i, 1);
				break;
			}
		}

		return array;
	},

	/**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
	compact: function(array) {
		var index = -1;
		var length = array == null ? 0 : array.length;
		var resIndex = 0;
		var result = [];

		while (++index < length) {
			var value = array[index];
			if (value) {
				result[resIndex++] = value;
			}
		}
		return result;
	},

	/**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
	defaultTo: function(value, defaultValue) {
		return (value == null || value !== value) ? defaultValue : value;
	}
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

	wrapTable: function() {
		$(".rte table").wrap("<div class=\"rte__table-wrapper\"></div>");
	},

	iframeReset: function() {
		var $iframeVideo = $(".rte iframe[src*=\"youtube.com/embed\"], .rte iframe[src*=\"player.vimeo\"]");
		var $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");

		$iframeVideo.each(function() {
			// Add wrapper to make video responsive
			$(this).wrap("<div class=\"rte__video-wrapper\"></div>");
		});

		$iframeReset.each(function() {
			// Re-set the src attribute on each iframe after page load
			// for Chrome's "incorrect iFrame content on 'back'" bug.
			// https://code.google.com/p/chromium/issues/detail?id=395791
			// Need to specifically target video and admin bar
			this.src = this.src;
		});
	}
};

slate.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	$(document)
		.on("shopify:section:load", this._onSectionLoad.bind(this))
		.on("shopify:section:unload", this._onSectionUnload.bind(this))
		.on("shopify:section:select", this._onSelect.bind(this))
		.on("shopify:section:deselect", this._onDeselect.bind(this))
		.on("shopify:section:reorder", this._onReorder.bind(this))
		.on("shopify:block:select", this._onBlockSelect.bind(this))
		.on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
	_createInstance: function(container, constructor) {
		var $container = $(container);
		var id = $container.attr("data-section-id");
		var type = $container.attr("data-section-type");

		constructor = constructor || this.constructors[type];

		if (typeof constructor === "undefined") {
			return;
		}

		var instance = $.extend(new constructor(container), {
			id: id,
			type: type,
			container: container
		});

		this.instances.push(instance);
	},

	_onSectionLoad: function(evt) {
		var container = $("[data-section-id]", evt.target)[0];
		if (container) {
			this._createInstance(container);
		}
	},

	_onSectionUnload: function(evt) {
		var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

		if (!instance) {
			return;
		}

		if (typeof instance.onUnload === "function") {
			instance.onUnload(evt);
		}

		this.instances = slate.utils.removeInstance(this.instances, "id", evt.detail.sectionId);
	},

	_onSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

		if (instance && typeof instance.onSelect === "function") {
			instance.onSelect(evt);
		}
	},

	_onDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

		if (instance && typeof instance.onDeselect === "function") {
			instance.onDeselect(evt);
		}
	},

	_onReorder: function(evt) {
		var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

		if (instance && typeof instance.onReorder === "function") {
			instance.onReorder(evt);
		}
	},

	_onBlockSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

		if (instance && typeof instance.onBlockSelect === "function") {
			instance.onBlockSelect(evt);
		}
	},

	_onBlockDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);

		if (instance && typeof instance.onBlockDeselect === "function") {
			instance.onBlockDeselect(evt);
		}
	},

	register: function(type, constructor) {
		this.constructors[type] = constructor;

		$("[data-section-type=" + type + "]").each(function(index, container) {
			this._createInstance(container, constructor);
		}.bind(this));
	}
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
	var moneyFormat = "${{amount}}";

	/**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
	function formatMoney(cents, format) {
		if (typeof cents === "string") {
			cents = cents.replace(".", "");
		}
		var value = "";
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || moneyFormat);

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = slate.utils.defaultTo(precision, 2);
			thousands = slate.utils.defaultTo(thousands, ",");
			decimal = slate.utils.defaultTo(decimal, ".");

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split(".");
			var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
			var centsAmount = parts[1] ? (decimal + parts[1]) : "";

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
			value = formatWithDelimiters(cents, 2);
			break;
		case "amount_no_decimals":
			value = formatWithDelimiters(cents, 0);
			break;
		case "amount_with_comma_separator":
			value = formatWithDelimiters(cents, 2, ".", ",");
			break;
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiters(cents, 0, ".", ",");
			break;
		case "amount_no_decimals_with_space_separator":
			value = formatWithDelimiters(cents, 0, " ");
			break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	return {
		formatMoney: formatMoney
	};
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

	/**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

	function preload(images, size) {
		if (typeof images === "string") {
			images = [images];
		}

		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}

	/**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
	function loadImage(path) {
		new Image().src = path;
	}

	/**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
	function imageSize(src) {
		/* eslint no-useless-escape: "off" */
		var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

		if (match) {
			return match[1];
		} else {
			return null;
		}
	}

	/**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === "master") {
			return this.removeProtocol(src);
		}

		var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

		if (match) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + "_" + size + suffix);
		} else {
			return null;
		}
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, "");
	}

	return {
		preload: preload,
		loadImage: loadImage,
		imageSize: imageSize,
		getSizedImageUrl: getSizedImageUrl,
		removeProtocol: removeProtocol
	};
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

	/**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
	function Variants(options) {
		this.$container = options.$container;
		this.product = options.product;
		this.singleOptionSelector = options.singleOptionSelector;
		this.originalSelectorId = options.originalSelectorId;
		this.enableHistoryState = options.enableHistoryState;
		this.currentVariant = this._getVariantFromOptions();

		$(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
	}

	Variants.prototype = $.extend({}, Variants.prototype, {

		/**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
		_getCurrentOptions: function() {
			var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
				var $element = $(element);
				var type = $element.attr("type");
				var currentOption = {};

				if (type === "radio" || type === "checkbox") {
					if ($element[0].checked) {
						currentOption.value = $element.val();
						currentOption.index = $element.data("index");

						return currentOption;
					} else {
						return false;
					}
				} else {
					currentOption.value = $element.val();
					currentOption.index = $element.data("index");

					return currentOption;
				}
			});

			// remove any unchecked input values if using radio buttons or checkboxes
			currentOptions = slate.utils.compact(currentOptions);

			return currentOptions;
		},

		/**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
		_getVariantFromOptions: function() {
			var selectedValues = this._getCurrentOptions();
			var variants = this.product.variants;
			var found = false;

			variants.forEach(function(variant) {
				var satisfied = true;

				selectedValues.forEach(function(option) {
					if (satisfied) {
						satisfied = (option.value === variant[option.index]);
					}
				});

				if (satisfied) {
					found = variant;
				}
			});

			return found || null;
		},

		/**
     * Event handler for when a variant input changes.
     */
		_onSelectChange: function() {
			var variant = this._getVariantFromOptions();

			this.$container.trigger({
				type: "variantChange",
				variant: variant
			});

			if (!variant) {
				return;
			}

			this._updateMasterSelect(variant);
			this._updateImages(variant);
			this._updatePrice(variant);
			this.currentVariant = variant;

			if (this.enableHistoryState) {
				this._updateHistoryState(variant);
			}
		},

		/**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
		_updateImages: function(variant) {
			var variantImage = variant.featured_image || {};

			var currentVariantImage = "";
			if (this.currentVariant !== null){
				currentVariantImage = this.currentVariant.featured_image;
			}

			if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
				return;
			}

			this.$container.trigger({
				type: "variantImageChange",
				variant: variant
			});
		},

		/**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
		_updatePrice: function(variant) {
			if (this.currentVariant !== null && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
				return;
			}

			this.$container.trigger({
				type: "variantPriceChange",
				variant: variant
			});
		},

		/**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
		_updateHistoryState: function(variant) {
			if (!history.replaceState || !variant) {
				return;
			}

			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
			window.history.replaceState({path: newurl}, "", newurl);
		},

		/**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
		_updateMasterSelect: function(variant) {
			$(this.originalSelectorId, this.$container)[0].value = variant.id;
		}
	});

	return Variants;
})();


/*================ Sections ================*/
$(document).ready(function(){
	$("#openSidenav").click(function() {
		$("#mobileSidenav").css("width", "300px");
	});

	$("#closeSidenav").click(function() {
		$("#mobileSidenav").css("width", "0px");
	});

	$(".dropdownMenu").css("display", "none");
	$(".inner-dropdownMenu").css("display", "none");

	$(".firstTier").click(function(e) {
		$(this).siblings("ul").toggle();
		e.stopPropagation();
		e.preventDefault();
	});

	$(".secondTier").click(function(e) {
		$(this).siblings("ul").toggle();
		e.stopPropagation();
		e.preventDefault();
	});

	$(".dropdownMenu li a").click(function() {
		if($(this).hasClass("highlight")){
			$(this).removeClass("highlight");
			$(this).find("svg").removeClass("selected");
		} else{
			$(this).addClass("highlight");
			$(this).find("svg").addClass("selected");
		}
	});
});
$(document).ready(function(){
	$("#openModal").click(function() {
		$("#country-modal").fadeIn( "slow", function() {
			$("#country-modal").css("display", "block");
			$("body").addClass("modal-open");
		});

	});

	$(".close").click(function() {
		$("#country-modal").fadeOut( "slow", function() {
			$("#country-modal").css("display", "none");
			$("body").removeClass("modal-open");
		});
	});

	$(window).click(function(event) {
		if (event.target ==  $("#country-modal")) {
			$("#country-modal").css("display", "none");
			$("body").removeClass("modal-open"); 
		}
	});
});
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

	var selectors = {
		addToCart: "[data-add-to-cart]",
		addToCartText: "[data-add-to-cart-text]",
		comparePrice: "[data-compare-price]",
		comparePriceText: "[data-compare-text]",
		originalSelectorId: "[data-product-select]",
		priceWrapper: "[data-price-wrapper]",
		productFeaturedImage: "[data-product-featured-image]",
		productJson: "[data-product-json]",
		productPrice: "[data-product-price]",
		productThumbs: "[data-product-single-thumbnail]",
		singleOptionSelector: "[data-single-option-selector]",
		productOptions: "[data-product-options-json]"
	};

	/**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
	function Product(container) {
		this.selectors = selectors;
		this.$container = $(container);
		// var sectionId = this.$container.attr("data-section-id");

		this.settings = {};
		this.namespace = ".product";

		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJson, this.$container).html()) {
			return;
		}

		this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
		this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr("src"));

		this.productOptions = JSON.parse($(selectors.productOptions, this.$container).html());

		slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

		this.initVariants();

		var productObject = this;
		// $(selectors.addToCart).click(function(e){
		// 	productObject.addToCartHandler(e, this, productObject);
		// });

		this.hoverZoom();
		this.relatedFix();
	}

	Product.prototype = $.extend({}, Product.prototype, {

		/**
	 * Handles change events from the variant inputs
	 */
		initVariants: function() {
			var options = {
				$container: this.$container,
				enableHistoryState: this.$container.data("enable-history-state") || false,
				singleOptionSelector: selectors.singleOptionSelector,
				originalSelectorId: selectors.originalSelectorId,
				product: this.productSingleObject
			};

			this.variants = new slate.Variants(options);

			this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this));
			this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this));
			this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this));
		},

		/**
	 * Updates the DOM state of the add to cart button
	 *
	 * @param {boolean} enabled - Decides whether cart is enabled or disabled
	 * @param {string} text - Updates the text notification content of the cart
	 */
		updateAddToCartState: function(evt) {
			var variant = evt.variant;

			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass("hide");
			} else {
				$(selectors.addToCart, this.$container).prop("disabled", true);
				$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
				$(selectors.priceWrapper, this.$container).addClass("hide");
				return;
			}

			if (variant.available) {
				$(selectors.addToCart, this.$container).prop("disabled", false);
				$(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
			} else {
				$(selectors.addToCart, this.$container).prop("disabled", true);
				$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
			}
		},

		/**
	 * Updates the DOM with specified prices
	 *
	 * @param {string} productPrice - The current price of the product
	 * @param {string} comparePrice - The original price of the product
	 */
		updateProductPrices: function(evt) {
			var variant = evt.variant;
			var $comparePrice = $(selectors.comparePrice, this.$container);
			var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

			$(selectors.productPrice, this.$container)
				.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

			if (variant.compare_at_price > variant.price) {
				$comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
				$compareEls.removeClass("hide");
			} else {
				$comparePrice.html("");
				$compareEls.addClass("hide");
			}
		},

		/**
	 * Updates the DOM with the specified image URL
	 *
	 * @param {string} src - Image src URL
	 */
		updateProductImage: function(evt) {
			var variant = evt.variant;
			var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

			$(selectors.productFeaturedImage, this.$container).attr("src", sizedImgUrl);
		},

		/**
	 * Event callback for Theme Editor `section:unload` event
	 */
		onUnload: function() {
			this.$container.off(this.namespace);
		},
		addToCartHandler: function(e, btn, productObject){
			e.preventDefault();
			var theId = $("[name='id']").val();
			var quantity = $("#Quantity").val();
			if (quantity == 0){ quantity = 1; }

			var templateData = {
				url: window.location.href,
				vendor: productObject.productSingleObject.vendor, 
				image: productObject.productSingleObject.featured_image,
				image_alt: productObject.productSingleObject.title,
				cart_number: 1,
				title: productObject.productSingleObject.title,
				brand: productObject.productSingleObject.brand,
				price: $(productObject.selectors.productPrice).text(),
				price_raw: productObject.productSingleObject.price,
				options: productObject.productOptions[theId],
				quantity: quantity,
				variant_id: theId
			};

			slate.cart.addItem({
				quantity: 1,
				id: theId,
				success: function(){
					slate.cart.cartCount += 1;
					Sidecart.addItem(templateData);
				},
				fail: function(data){
					alert(data.description);
				}
			});
		},

		hoverZoom: function(){
			if ($(".image-featured").length){
				$(".imgWrapper").zoom({
					url: $(".image-featured").attr("src"),
					magnify: 1.3
				});
			}
			if ($(".image-select").length){
				$(".image-select a").click(function(){
					var newSrc = $(this).find("img").first().attr("src");
					$(".image-featured").trigger("zoom.destroy");

					$(".image-featured").find("img").attr("src", newSrc);
					$(".imgWrapper").zoom({
						url: newSrc,
						magnify: 1.3
					});
				});
			}
		},

		relatedFix: function(){
			$(".similarproducts").imagesLoaded(function(){
				$(window).resize(function(){
					$(".product-image-wrapper").each(function(){
						//reset
						$(this).css("min-height", "");
					});
					var $row = $(".similarproducts");
					var maxHeight = 0;
					var $children = $row.children();
					$children.each(function(){
						var itemHeight = $(this).height();
						if (itemHeight > maxHeight){ maxHeight = itemHeight; }
					});

					$children.each(function(){
						var $this = $(this);
						var metaHeight = $this.find(".meta").height();

						$this.find(".product-image-wrapper").css("min-height", maxHeight - metaHeight);
					});
				}).resize();
			});
		}
	});

	return Product;
})();

$(document).ready(function(){
	var $header, headerHeight;
	/*
	* Assigns/removes appearance-changing class for header based on scroll.
	*/
	$(document).scroll(function() {
		if ($("#mobile-indicator").css("display") === "none"){
			if ($(document).scrollTop() > headerHeight){
				//Scrolled header
				$("main").css("padding-top", $header.height());
				$header.addClass("scrolled-header");
				if( $("#topbar").css("display") == "block"){
					$("#topbar").hide();
				}
				if( $(".teaser").css("display") == "block"){
					$(".teaser").hide();
				}
				$("#topbar").hide();
				$(".branding").removeClass("large-up--one-third").addClass("large-up--two-twelfths");
				$("nav").removeClass("large-up--one-whole").addClass("large-up--seven-twelfths small-header");
				$("#rightIcons").removeClass("large-up--one-third").addClass("large-up--three-twelfths small-header");
				$(".small-header").css("height", $(".branding").height());
				$(".site-nav__megamenu").removeClass("big-megamenu").addClass("small-megamenu");
			} else {
				//Normal header
				$("main").css("padding-top", $header.height());
				if( $("#topbar").css("display") == "none"){
					$("#topbar").show();
				}
				if( $(".teaser").css("display") == "none"){
					$(".teaser").show();
				}
				$header.removeClass("scrolled-header");
				$(".small-header").css("height", "inherit");
				$("#topbar").show();
				$(".branding").removeClass("large-up--two-twelfths").addClass("large-up--one-third");
				$("nav").removeClass("large-up--seven-twelfths small-header").addClass("large-up--one-whole");
				$("#rightIcons").removeClass("large-up--three-twelfths small-header").addClass("large-up--one-third");
				$(".site-nav__megamenu").removeClass("small-megamenu").addClass("big-megamenu");
				headerHeight = $header.height();
			}
		}
	});

	$(window).resize(function(){
		$header = $("#shopify-section-header");
		headerHeight = $header.height();
		/*
		*	ADDS PADDING TOP TO SITE CONTENT FOR POSITION FIXED HEADER
		*/
		$("main").css("padding-top", headerHeight);


		if ($("#mobile-indicator").css("display") !== "none"){
			$header.removeClass("scrolled-header");
			$(".small-header").css("height", "inherit");
			$(".branding").removeClass("large-up--two-twelfths").addClass("large-up--one-third");
			$("nav").removeClass("large-up--seven-twelfths small-header").addClass("large-up--one-whole");
			$("#rightIcons").removeClass("large-up--three-twelfths small-header").addClass("large-up--one-third");
			$(".site-nav__megamenu").removeClass("small-megamenu").addClass("big-megamenu");
		}
	}).resize();
});

$(document).ready(function(){
	$(window).resize(function(){
		if ($(window).width() >= 990){
			var $items = $("#shopify-section-footer .footer-content .grid__item");
			var maxHeight = 0;
			$items.each(function(){
				var height = $(this).height();
				if (height > maxHeight){ maxHeight = height; }
			});
			$items.each(function(){
				$(this).height(maxHeight);
			});
			$(".country-title").text("Country");
		}
	}).resize();

	$(".tm-totop-scroller").click(function(){
		$("html, body").animate({scrollTop : 0},800);
	});
});
$(document).ready(function(){
	var teasers = $("a[id^='teaser-']"); // builds an array of elements that have an id containing "teaser- "
	var current = $(teasers[0]); // first teaser to be displayed is just the first one in the array.
	current.show(); // teasers are all display none by default, so this shows the first one.

	/* LEFT CLICK */
	$(".left-arrow").click(function(){
		teaserLeft();
		resetTimer();
	});

	/* RIGHT CLICK */
	$(".right-arrow").click(function(){
		teaserRight();
		resetTimer();
	});

	var timer  = setInterval(teaserRight, 5000);

	function teaserRight(){
		var currentPos = parseInt(teasers.index(current)); //get the index position of the currently displayed teaser
		if (currentPos < parseInt(teasers.length - 1)){ //if the index is not the end of the array
			current.fadeOut("fast", function(){ //fade out the current teaser, delay further functions until animation completes
				var newPos = parseInt(currentPos + 1); //find the new teaser's index
				current = $(teasers[newPos]); //set the new teaser to be current
				current.fadeIn(); //display the new teaser
			});
		} else if (currentPos == parseInt(teasers.length - 1)){ //if the index is the final position in the array
			current.fadeOut("fast", function(){ //fade out the current teaser, delay further actions until animation completion
				current = $(teasers[0]); //set the new teaser as the first position in array
				current.fadeIn(); // show the new teaser
			});
		}
	}

	function teaserLeft(){
		var currentPos = parseInt(teasers.index(current)); //get the index position of the currently displayed teaser
		if (currentPos > 0){ // if the index is not the first position in the array
			current.fadeOut("fast", function(){ // fade out the current teaser, delay further functions until animation completes
				var newPos = parseInt(currentPos - 1); // find the index of the new teaser
				current = $(teasers[newPos]); //set the new teaser to be current
				current.fadeIn(); // show the new teaser
			});
		} else if (currentPos == 0){ // if the index is the first position in the array
			current.fadeOut("fast",function(){ // fade out current teaser, delay further functions until animation completes
				var newPos = parseInt(teasers.length - 1); // set the new teaser's index to be the last position in the array
				current = $(teasers[newPos]); // set the new teaser to be current
				current.fadeIn(); // show the new teaser
			});
		}
	}

	function resetTimer(){
		clearInterval(timer);
		timer = setInterval(teaserRight, 5000);
	}
});
// eslint-disable-next-line no-unused-vars
var Sidecart = (function(){
	var _instance = {};

	var cart = slate.cart;
	var sidecartTemplate = doT.template($("#sidecart_item").html());

	var $sidecart = $("#sidecart");

	_instance.init = function(){
		$("#header a[href='/cart']").click(function(e){
			//Don't bother on the cart page
			if (!$("body").hasClass("template-cart")){
				$("body").toggleClass("sidecart-active");
			}
			e.preventDefault();
			e.stopPropagation();
		});

		$("body").click(function(){
			if ($("body").hasClass("sidecart-active")){
				_instance.hide();
			}
		});

		$("#sidecart").click(function(e){
			e.stopPropagation();
		});

		$sidecart.find(".remove").click(removeButtonHandler);
	};

	_instance.show = function(){
		$("body").addClass("sidecart-active");
	};

	_instance.hide = function(){
		$("body").removeClass("sidecart-active");
	};

	_instance.toggle = function(){
		$("body").toggleClass("sidecart-active");
	};

	_instance.addItem = function(data){
		//Check if we already have any items to know if we should append or add fresh
		if ($("#sidecart").hasClass("has-items")){
			$sidecart.find(".items .remove").each(function(){
				var $this = $(this);
				$this.attr("data-line", (parseInt($this.attr("data-line")) + 1));
			});
		} else {
			$sidecart.addClass("has-items");
		}

		var $existingVariant = $sidecart.find("[data-variant-id='"+data.variant_id+"']");
		if ($existingVariant.length){
			var existingQty = parseInt($existingVariant.find(".quantity").html());
			$existingVariant.find(".quantity").html(existingQty + data.quantity);
		} else {
			//Add the template
			$("#sidecart .items").prepend(sidecartTemplate(data));
			var $item = $("#cart-line-"+cart.cartCount);
			$item.find(".remove").click(removeButtonHandler);
		}

		var $subtotal = $("#sidecart .subtotal");

		var newSubtotal = (parseInt($subtotal.attr("data-subtotal")) + data.price_raw);
		$subtotal.attr("data-subtotal", newSubtotal);
		$subtotal.children("span").html(slate.Currency.formatMoney(newSubtotal, theme.moneyFormat));

		_instance.show();
	};

	var removeButtonHandler = function(e){
		var $this = $(this);
		cart.cartCount--;
		e.preventDefault();
		$this.addClass("removing");
		$("#sidecart .items .remove").each(function(){
			var $remove = $(this);
			if (!$remove.hasClass("removing")){
				$remove.attr("data-line", (parseInt($remove.attr("data-line")) - 1));
			}
		});

		cart.rmvItem($this.attr("data-line"), function(){
			var $item = $this.parent().parent();
			$item.fadeOut(400, function(){
				$item.remove();
				if (cart.cartCount == 0){
					$sidecart.removeClass("has-items");
				}
			});
		});
	};

	return _instance;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
	var $newAddressForm = $("#AddressNewForm");

	if (!$newAddressForm.length) {
		return;
	}

	// Initialize observers on address selectors, defined in shopify_common.js
	if (Shopify) {
		new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
			hideElement: "AddressProvinceContainerNew"
		});
	}

	// Initialize each edit form's country/province selector
	$(".address-country-option").each(function() {
		var formId = $(this).data("form-id");
		var countrySelector = "AddressCountry_" + formId;
		var provinceSelector = "AddressProvince_" + formId;
		var containerSelector = "AddressProvinceContainer_" + formId;

		new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
			hideElement: containerSelector
		});
	});

	// Toggle new/edit address forms
	$(".address-new-toggle").on("click", function() {
		$newAddressForm.toggleClass("hide");
	});

	$(".address-edit-toggle").on("click", function() {
		var formId = $(this).data("form-id");
		$("#EditAddress_" + formId).toggleClass("hide");
	});

	$(".address-delete").on("click", function() {
		var $el = $(this);
		var formId = $el.data("form-id");
		var confirmMessage = $el.data("confirm-message");
		if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
			Shopify.postLink("/account/addresses/" + formId, {parameters: {_method: "delete"}});
		}
	});
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
	var config = {
		recoverPasswordForm: "#RecoverPassword",
		hideRecoverPasswordLink: "#HideRecoverPasswordLink"
	};

	if (!$(config.recoverPasswordForm).length) {
		return;
	}

	checkUrlHash();
	resetPasswordSuccess();

	$(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
	$(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

	function onShowHidePasswordForm(evt) {
		evt.preventDefault();
		toggleRecoverPasswordForm();
	}

	function checkUrlHash() {
		var hash = window.location.hash;

		// Allow deep linking to recover password form
		if (hash === "#recover") {
			toggleRecoverPasswordForm();
		}
	}

	/**
   *  Show/Hide recover password form
   */
	function toggleRecoverPasswordForm() {
		$("#RecoverPasswordForm").toggleClass("hide");
		$("#CustomerLoginForm").toggleClass("hide");
	}

	/**
   *  Show reset password success message
   */
	function resetPasswordSuccess() {
		var $formState = $(".reset-password-success");

		// check if reset password form was successfully submited.
		if (!$formState.length) {
			return;
		}

		// show success message
		$("#ResetSuccess").removeClass("hide");
	}
})();

$(document).ready(function(){
	Shopify.queryParams = {};
	if (location.search.length) {
		for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++) {
			aKeyValue = aCouples[i].split("=");
			if (aKeyValue.length > 1) {
				Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
			}
		}
	}
	jQuery("#sorting")
		.bind("change", function() {
			Shopify.queryParams.sort_by = jQuery(this).val();
			location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20");
		});


	$(".product-grid").imagesLoaded(function(){
		$(window).resize(function(){
			$(".product-image-wrapper").each(function(){
				//reset
				$(this).css("min-height", "");
			});

			$(".productGridRow").each(function(){
				var $row = $(this);
				var maxHeight = 0;
				var $children = $row.children();
				$children.each(function(){
					var itemHeight = $(this).height();
					if (itemHeight > maxHeight){ maxHeight = itemHeight; }
				});

				$children.each(function(){
					var $this = $(this);
					var metaHeight = $this.find(".meta").height();

					$this.find(".product-image-wrapper").css("min-height", maxHeight - metaHeight);
				});
			});
		}).resize();
	});

	$(".collection-container").imagesLoaded(function(){
		$(window).resize(function(){
			$(".collection-sidebar-desktop").height($(".products-grid").height()- 100);
			$(".theLoader").fadeOut();
			$(".productGridRow").css("visibility", "1");
		}).resize();
	});

	$("#collection-sidebar-toggle").click(function(){
		$(".collection-sidebar-mobile .collection-sidebar").slideToggle();
	});
});
$(document).ready(function(){
	$(".image-select a").click(function(event){
		event.preventDefault();
		$(".image-featured").attr("src", $(this).attr("href"));
	});

	$('.unitConversion a').click(function(evt){
		var $a = $(this);
		var $table = $(this).parent().siblings('table');
		if ($table.attr("data-unit") == "cm"){
			//cm to in
			$table.find("td:not(:first-child) span").each(function(){
				var $this = $(this);
				var txt = $this.text();
				$(this).attr("data-orig", txt);
				var cm = parseFloat(txt);
				var inch = cm * (1/2.54);
				$this.text(Number((inch).toFixed(1)));
			});
			$table.attr("data-unit", "in");
		} else {
			//in to cm
			$table.find("td span").each(function(){
				var $this = $(this);
				$this.text($this.attr("data-orig"));
			});
			$table.attr("data-unit", "cm");
		}
		$(".unitConversion a.active").removeClass("active");
		$a.addClass("active");
	});
});

$(document).ready(function() {
	var sections = new slate.Sections();
	sections.register("product", theme.Product);

	// Common a11y fixes
	slate.a11y.pageLinkFocus($(window.location.hash));

	$(".in-page-link").on("click", function(evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
	});

	// Wrap videos in div to force responsive layout.
	slate.rte.wrapTable();
	slate.rte.iframeReset();

	// Apply a specific class to the html element for browser support of cookies.
	if (slate.cart.cookiesEnabled()) {
		document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies");
	}

	slate.cart.init();
	// Sidecart.init();
});
